import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

export default function ArticleCard({ article }: { article: Article }) {
  return (
    <Link
      to={`/articles/${article.slug}`}
      className="group flex flex-col sm:flex-row gap-5 p-5 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
    >
      <div className="w-full sm:w-48 flex-shrink-0 aspect-video sm:aspect-auto sm:h-32 rounded-md overflow-hidden">
        <img
          src={article.coverImage}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-2 flex-wrap">
          <span className="inline-block px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium">
            {article.category}
          </span>
          <span className="text-xs text-foreground-400">{article.publishedAt}</span>
          <span className="text-xs text-foreground-400">{article.readTime} 分钟阅读</span>
        </div>
        <h3 className="text-base font-heading font-semibold text-foreground-900 line-clamp-1 mb-2 group-hover:text-primary-600 transition-colors">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed mb-3">
          {article.excerpt}
        </p>
        <div className="flex items-center gap-2 flex-wrap">
          {article.tags.map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}